import http from "../http-common";
import httpCommon from "../http-common-auth";

class CourseDataService {
  getAllCourses() {
    return http.get("/courses");
  }

  getCoursesPaginated(page = 0, size = 10, title = null) {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('size', size);
    if (title) {
      params.append('title', title);
    }
    return http.get(`/courses/paginated?${params.toString()}`);
  }

  getCourseById(id) {
    return http.get(`/courses/${id}`);
  }

  getTypingCourseById(id) {
    return http.get(`/typing-courses/${id}`);
  }

  getTestById(id) {
    return http.get(`/tests/${id}`);
  }

  getTypingTestByTypingCourseId(id) {
    return http.get(`/typing-courses/${id}/tests`);
  }

  createTypingTest(id,data) {
    return http.post(`/typing-courses/${id}/test`, data);
  }

  updateTest(id, data) {
    return http.put(`/tests/${id}`, data);
  }

  deleteTest(id) {
    return http.delete(`/tests/${id}`);
  }

  get(id) {
    return http.get(`/courses/${id}`);
  }

  create(data) {
    return http.post("/courses", data);
  }

  update(id, data) {
    return http.put(`/courses/${id}`, data);
  }

  delete(id) {
    return http.delete(`/courses/${id}`);
  }

  deleteAll() {
    return http.delete(`/courses`);
  }

  findByTitle(title) {
    return http.get(`/courses?title=${title}`);
  }

  // Admin methods for TypingCourse
  getAllTypingCourses() {
    return http.get("/typing-courses");
  }

  createTypingCourse(courseId, data) {
    return http.post(`/courses/${courseId}/typing-courses`, data);
  }

  updateTypingCourse(id, data) {
    return http.put(`/typing-courses/${id}`, data);
  }

  deleteTypingCourse(id) {
    return http.delete(`/typing-courses/${id}`);
  }

  getTypingCoursesByCourseId(courseId) {
    return http.get(`/courses/${courseId}/typing-courses`);
  }
  
  // New method to fetch typing courses for the authenticated user
  getTypingCoursesForAuthenticatedUser() {
    return http.get("/user/typing-courses");
  }

  // New method to add a typing course to the authenticated user
  addTypingCourseToAuthenticatedUser(courseId, enrolledAt) {
    return http.post("/user/typing-courses", null, {
      params: {
        courseId,
        enrolledAt,
      },
    });
  }

  // Admin method to get user subscribed courses
  getUserSubscribedCourses(userId) {
    return http.get(`/admin/user/${userId}/courses`);
  }

  /**
   * Admin: extend or set expiry for a user's typing course subscription.
   * @param payload { addDays?: number, newExpiresAt?: string } (ISO local datetime)
   */
  updateUserTypingCourseExpiry(userId, typingCourseId, payload) {
    return http.put(`/admin/user/${userId}/typing-courses/${typingCourseId}/expiry`, payload);
  }

  /**
   * Admin: grant a typing course to a user without payment (enrollment + expiry from course validity).
   * @param enrolledAt optional ISO local string e.g. 2026-03-29T10:30:00
   */
  adminGrantTypingCourse(userId, typingCourseId, enrolledAt) {
    const body = { typingCourseId };
    if (enrolledAt) body.enrolledAt = enrolledAt;
    return http.post(`/admin/user/${userId}/typing-courses`, body);
  }

  // Admin method to update course validity and recalculate expiration dates
  updateCourseValidity(typingCourseId, validity) {
    return httpCommon.put(`/admin/typing-courses/${typingCourseId}/validity`, { validity });
  }

  getFreeCourseStatus() {
    return http.get("/user/free-course-status");
  }

  getAdminFreeCourseLimit() {
    return http.get("/admin/free-course-limit");
  }

  updateAdminFreeCourseLimit(limit) {
    return http.put("/admin/free-course-limit", { limit });
  }

  /**
   * Admin: upload exam rules PDF to Oracle Object Storage; response data contains pdfUrl for rulesPdfUrl.
   */
  uploadTypingRulesPdf(file) {
    const form = new FormData();
    form.append("file", file);
    return http.post("/courses/admin/typing-rules/upload", form);
  }

  /** Admin: remove a previous rules PDF from OCI (object key must start with typing-rules/). */
  deleteTypingRulesObject(objectKey) {
    return http.delete("/courses/admin/typing-rules", {
      params: { objectKey },
    });
  }
}

const courseDataService = new CourseDataService();
export default courseDataService;